import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import { parseDecimal } from '../../../../../libs/utils'
import { CommissionPaymentForm } from './types'
import { $params } from '../../../../../features/router'
import { initialCommissionModalState } from './const'

const buildBody = (data: CommissionPaymentForm, walletOverride?: string) => ({
  wallet: walletOverride || data.walletId,
  walletId: walletOverride || data.walletId,
  product: data.product,
  amount: parseDecimal(data.amount),
  currency: data.currency,
  exchangeRate: parseDecimal(data.exchangeRate),
  comment: data.comment,
  dateTime: data.dateTime,
})

export const addCommissionPaymentMounted = createEvent<CommissionPaymentForm>()
export const editCommissionPaymentMounted = createEvent<CommissionPaymentForm>()
export const deleteCommissionPaymentMounted = createEvent<{ id: string }>()
export const getCommissionPaymentByIdMounted = createEvent<{ id: string }>()
export const setCommissionPaymentForm = createEvent<CommissionPaymentForm>()

export const $CommissionPaymentForm = restore(
  setCommissionPaymentForm,
  initialCommissionModalState,
)

export const addCommissionPayment = fx<ReturnType<typeof buildBody>, void>({
  method: 'POST',
  url: `/finance/commission_payment`,
})

export const editCommissionPayment = fx<ReturnType<typeof buildBody>, void>({
  method: 'PUT',
  url: `/finance/commission_payment/{id}`,
})

export const getCommissionPaymentById = fx<
  { id: string },
  CommissionPaymentForm
>({
  method: 'GET',
  url: `/finance/commission_payment/{id}`,
})

export const deleteCommissionPayment = fx<CommissionPaymentForm, void>({
  method: 'DELETE',
  url: `/finance/commission_payment/{id}`,
})

sample({
  clock: addCommissionPaymentMounted,
  source: $params,
  fn: (params, data) => ({
    body: buildBody(data, params?.walletID),
  }),
  target: addCommissionPayment,
})

sample({
  clock: editCommissionPaymentMounted,
  fn: (data) => ({
    url: `/finance/commission_payment/${data.id}`,
    body: buildBody(data),
  }),
  target: editCommissionPayment,
})

sample({
  clock: deleteCommissionPaymentMounted,
  fn: ({ id }) => ({ url: `/finance/commission_payment/${id}` }),
  target: deleteCommissionPayment,
})

sample({
  clock: getCommissionPaymentByIdMounted,
  fn: ({ id }) => ({ url: `/finance/commission_payment/${id}` }),
  target: getCommissionPaymentById,
})

sample({
  clock: getCommissionPaymentById.doneData,
  fn: (doneData) => doneData.body,
  target: setCommissionPaymentForm,
})
